(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        if (e.target.hasAttribute('data-mt-contar')) contar(e.target);
        observer.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    return observer;
  }

  function initReveals(root) {
    var els = root.querySelectorAll('.mt-reveal, [data-mt-contar], .mt-hero, .mt-paso');
    var obs = getObserver();
    els.forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      if (!obs || reduce) { el.classList.add('mt-visible'); if (el.hasAttribute('data-mt-contar')) contar(el, true); return; }
      obs.observe(el);
    });
  }

  function contar(el, inmediato) {
    if (el.dataset.mtContado) return;
    el.dataset.mtContado = '1';
    var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
    var dec = (String(fin).split('.')[1] || '').length;
    if (inmediato || reduce) { el.textContent = fin.toFixed(dec); return; }
    var t0 = null, dur = 1600;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var v = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = v.toFixed(dec);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initFaq(root) {
    root.querySelectorAll('.mt-faq__pregunta').forEach(function (b) {
      if (b.dataset.mtInit) return;
      b.dataset.mtInit = '1';
      b.addEventListener('click', function () {
        var item = b.closest('.mt-faq__item');
        var abierto = item.classList.toggle('mt-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initTimeline() {
    var listas = document.querySelectorAll('.mt-pasos__lista');
    if (!listas.length) return;
    function actualizar() {
      listas.forEach(function (l) {
        var r = l.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh * 0.7 - r.top) / r.height;
        l.style.setProperty('--mt-progreso', Math.max(0, Math.min(1, p)).toFixed(3));
      });
    }
    if (!window.__mtTimeline) {
      window.__mtTimeline = true;
      document.addEventListener('scroll', function () { requestAnimationFrame(actualizar); }, { passive: true, capture: true });
      window.addEventListener('resize', actualizar, { passive: true });
    }
    actualizar();
  }

  function initMagnetico(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    root.querySelectorAll('.mt-magnetico').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.3;
        btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  function initProducto(root) {
    root.querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var principal = sec.querySelector('.mt-prod__principal img');
      sec.querySelectorAll('.mt-prod__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = m.getAttribute('data-src');
            principal.srcset = '';
            principal.style.opacity = '1';
          }, 150);
          sec.querySelectorAll('.mt-prod__mini').forEach(function (x) { x.classList.remove('mt-activa'); });
          m.classList.add('mt-activa');
        });
      });

      var qty = sec.querySelector('.mt-prod__cantidad input');
      sec.querySelectorAll('.mt-prod__cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += b.getAttribute('data-paso') === 'mas' ? 1 : -1;
          qty.value = Math.max(1, v);
        });
      });

      var datos = sec.querySelector('[data-mt-variantes]');
      var selects = sec.querySelectorAll('[data-mt-opcion]');
      if (datos && selects.length) {
        var variantes = JSON.parse(datos.textContent);
        var input = sec.querySelector('input[name="id"]');
        var precio = sec.querySelector('[data-mt-precio]');
        var antes = sec.querySelector('[data-mt-antes]');
        var boton = sec.querySelector('.mt-prod__boton');
        var txtBoton = boton ? boton.getAttribute('data-texto') : '';
        var txtAgotado = boton ? boton.getAttribute('data-agotado') : '';
        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
            var v = variantes.find(function (vv) { return vv.options.every(function (o, i) { return o === elegidas[i]; }); });
            if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = txtAgotado; } return; }
            input.value = v.id;
            if (precio) precio.textContent = v.precio;
            if (antes) { antes.textContent = v.antes || ''; antes.hidden = !v.antes; }
            if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? txtBoton : txtAgotado; }
          });
        });
      }

      var form = sec.querySelector('form[action*="/cart/add"]');
      var msg = sec.querySelector('.mt-prod__mensaje');
      if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var boton = form.querySelector('.mt-prod__boton');
          if (boton) boton.disabled = true;
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
          }).then(function (r) {
            if (!r.ok) throw new Error('add');
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          }).catch(function () {
            if (boton) boton.disabled = false;
            if (msg) msg.textContent = msg.getAttribute('data-error');
          });
        });
      }
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root);
    initFaq(root);
    initMagnetico(root);
    initProducto(root);
    initTimeline();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
